var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.788 19.033H4.481v-9.95h3.307v9.95ZM6.135 7.724h-.022c-1.11 0-1.827-.764-1.827-1.719 0-.976.74-1.719 1.87-1.719 1.132 0 1.828.743 1.85 1.72 0 .954-.718 1.718-1.871 1.718Zm13.58 11.31h-3.308V13.71c0-1.338-.479-2.25-1.675-2.25-.914 0-1.458.615-1.697 1.21-.088.212-.109.51-.109.807v5.556H9.619s.043-9.017 0-9.95h3.307v1.409c.44-.678 1.226-1.643 2.98-1.643 2.177 0 3.808 1.423 3.808 4.479v5.705Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4a2bf4ecc3495a955f0f0cd3b329ee1b.svg";
export { ForwardRef as ReactComponent };